export default "/* css customize identity vaklidation */\n\n.frame_dimension {\n  width: 100%;\n  height: 650px;\n}";